import { IconProps } from './types';

export const CoinIcon = ({ title = 'Coin Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64" {...props}>
        <title>{title}</title>
        <circle cx="41" cy="41" r="15" fill="#D9DBDD"></circle>
        <circle cx="26" cy="26" r="18" fill="#FB0"></circle>
        <path
            fill="#0A2F73"
            d="M27 20a3 3 0 0 0-3 3v3h3a1 1 0 1 1 0 2h-3v4h6v-2a1 1 0 1 1 2 0v2a2 2 0 0 1-2 2h-9a1 1 0 1 1 0-2h1v-4h-1a1 1 0 1 1 0-2h1v-3a5 5 0 0 1 10 0 1 1 0 1 1-2 0 3 3 0 0 0-3-3"
        ></path>
    </svg>
);
